import React, {useEffect, useState} from 'react';
import { useTranslation } from "react-i18next";
import packageJson from "../../package.json";
import { getCurrentUser } from '../auth';
import { Link } from "react-router-dom";

import {doAllSync} from "../Sync/syncUtils";
import {cleanAllTables} from "../db";

const Settings = () => {
    const { t, i18n } = useTranslation();
    const [user, setUser] = useState(null);

    useEffect(() => {
        const fetchUser = async () => {
            setUser(getCurrentUser());
        };
        fetchUser();
    }, []);

    const handleLogout = () => {
        setUser(null);
        doAllSync(true);
        cleanAllTables();
        localStorage.removeItem('biathlonhubUser');
    };

    return (
        <div className="p-4 flex flex-col h-full">
            <h1 className="text-2xl uppercase text-center font-black transform -skew-x-12 shrink-0 pb-4">{t("settings.headline")}</h1>
            <div className="grow overflow-y-auto overflow-x-hidden flex flex-col gap-8">
                <section>
                    <h2 className="text-lg uppercase font-black transform -skew-x-12 border-b-2 border-[var(--light-color)]">{t("settings.user")}</h2>
                    {user ? (
                        <div className="pt-4 flex flex-col gap-4">
                            <h3 className="font-bold">{user.username || `${user.firstname} ${user.lastname} (${user.username})`}</h3>
                            <div className="px-2">
                                <button onClick={handleLogout} className="button-secondary">{t('settings.user.logout')}</button>
                            </div>
                        </div>
                    ) : (
                        <div className="pt-4 flex flex-col gap-4">
                            <div>{t('settings.user.currentlyNoUser')}</div>
                            <div className="px-2 flex gap-2">
                                <Link to="/login" className="button-primary">{t('settings.user.login')}</Link>
                                <Link to="/registration" className="button-secondary">{t('settings.user.register')}</Link>
                            </div>
                        </div>
                    )}
                </section>
                <section>
                    <h2 className="text-lg uppercase font-black transform -skew-x-12 border-b-2 border-[var(--light-color)]">{t("settings.general")}</h2>
                    <div className="pt-4 flex flex-col gap-4 md:grid md:grid-cols-2">
                        <div className="flex flex-col gap-2">
                            <label htmlFor="settingsLanguage" className="font-bold">
                                {t("settings.general.language")}
                            </label>
                            <div className="form-input-wrap">
                                <select
                                    value={i18n.language}
                                    className="" id="settingsLanguage" onChange={(event) => i18n.changeLanguage(event.target.value)}>
                                    <option value="en">English</option>
                                    <option value="cz">Čeština</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </section>
                <section>
                    <h2 className="text-lg uppercase font-black transform -skew-x-12 border-b-2 border-[var(--light-color)]">{t("settings.info")}</h2>
                    <table className="mt-4">
                        <tbody>
                            <tr>
                                <th className="pr-1 py-1">{t("settings.info.author")}</th>
                                <td className="pl-1 py-1">Martin Přibyl</td>
                            </tr>
                            <tr>
                                <th className="pr-1 py-1">{t("settings.info.version")}</th>
                                <td className="pl-1 py-1">{packageJson.version}</td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </div>
        </div>
    );
};

export default Settings;